import { useTemplateContext } from "@/contexts/templateContext";
import { createTemplateSchema } from "@/schemas/template/create";
import { useTemplateFormFields } from "@/hooks/template/useTemplateFormFields";
import { ImageUploadStep, FormFieldsStep } from "../commos/FormStep";

export const FirstStep = () => {
    const { onUpload, onClearFile } = useTemplateContext();

    return (
        <ImageUploadStep
            onUpload={onUpload}
            onClearFile={onClearFile}
            fileConfiguration={{
                title: "Carga de imágenes para un nuevo Template",
                description: "Carga el archivo de imagen de Template",
                maxSizeMB: 2,
            }}
        />
    );
};

export const SecondStep = () => {
    const { onComplete, isFetching, catalogs } = useTemplateContext();
    const { fields } = useTemplateFormFields({ catalogs });

    return (
        <FormFieldsStep
            schema={createTemplateSchema}
            defaultValues={{
                name: "",
                brand: "",
                format: "",
                type: "",
            }}
            fields={fields as any}
            onComplete={onComplete}
            isFetching={isFetching}
            formId="template-general-info"
            description="Aquí podrás ingresar la información correspondiente a tu Template"
            className="px-10 pt-3 pb-6"
        />
    );
};